// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { AreaChart as RawAreaChart } from "lucide-react";
export const AreaChart = /* @__PURE__ */ createIcon(RawAreaChart, "AreaChart", 2);
